import React, { useState } from "react";
import Modal from "../Modal";
import { connect, useDispatch, useSelector, useStore } from "react-redux";
import { reduxForm, reset, Field, getFormValues, SubmissionError } from "redux-form";
import { token as tokenSelector, token } from "../../modules/auth";
import { Input, Radio } from "../../ui";
import { Toggle } from "../Form";
import { ButtonPrimary, ButtonSpan } from "../Button";
import {  } from "redux-form";
import { editHotelGroupDealPercentage } from "../../redux/actions";
const mapStateToProps = (state, props) => {
    return {
        initialValues: {
          commission_applied_on: 'Gross'
        }
    }
};
const mapDispatchToProps = {
  editHotelGroupDealPercentage,
};


const Wrapper = ({ children, onClose }) => (
  <Modal>
    <div className="modal">
      <div
        className="modal-inner"
        style={{
          width: 600,
          maxWidth: "90%",
        }}
      >
        <ButtonSpan className="m-3 absolute pin-t pin-r z-10" onClick={onClose}>
          <i className="fas fa-times-circle fa-2x ml-3" />
        </ButtonSpan>
        {children}
      </div>
    </div>
  </Modal>
);


let PreferredProgrammeCommercialDealModal = ({
                                               handleSubmit,
                                               onClose,
                                               hotelGroup,
  programme,
                                               editHotelGroupDealPercentage
                        }) => {
  const token = useSelector(tokenSelector);
  const values = useSelector(getFormValues('preferredProgrammeCommercialDealModal'));
  let onSubmit = formValues => {
    if(formValues) {
      editHotelGroupDealPercentage(hotelGroup.id, programme.id, token, formValues).then((response) => {
      })
    }

  };
  return (
    <>
      <Wrapper onClose={onClose}>
        <div className="modal">
          <div
            className="modal-inner"
            style={{
              width: 600,
              maxWidth: "90%",
            }}
          >
            <form className="relative pb-16" onSubmit={handleSubmit(onSubmit)}>
              <div className={"flex justify-between"}>
                <h1 className={"mb-5"}>Add Commission Rate</h1>
              </div>
              <div className={"row"}>
                <div className={`col col-w-1/3 py-2`}>
                  <Field
                    label={"Commission %"}
                    name="default_event_commission_percentage"
                    component={Input}
                    additionalInputClass="text-right"
                    size="sm"
                    additionalReadonlyClass={"text-right"}
                  />
                </div>
                <div className={`col col-w-1/3 py-2`}>
                  <Field
                    label={"Includes Vat"}
                    name="commission_vat_inclusive"
                    component={Toggle}
                  />
                </div>
                <div className={`col col-w-1/3 py-2`}>
                  <Field
                    label={"Applied On"}
                    name="commission_applied_on"
                    component={Radio}
                    options={["Gross", "Net"]}
                  />
                </div>
              </div>

              <div className="absolute pin-b pin-r">
                <ButtonPrimary
                  classes="px-5"
                  style={{ height: 57, lineHeight: "57px" }}
                  onClick={() => onSubmit(values)}
                >
                 Save
                </ButtonPrimary>
              </div>


            </form>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

PreferredProgrammeCommercialDealModal = reduxForm({
  form: "preferredProgrammeCommercialDealModal",
  enableReinitialize: true,
})(PreferredProgrammeCommercialDealModal);

export default connect(mapStateToProps, mapDispatchToProps)(PreferredProgrammeCommercialDealModal);
